<template>
  <div v-if="article" class="bulletin-container">
    <header>
      <h1>
        {{ article.title }}
      </h1>

      <div class="article-info">
        <div class="article-categories">
          <a-tag
              v-for="category in article.categories" :key="category.id">
            {{ category.name }}
          </a-tag>
        </div>

        <div>Közzétéve: {{ moment(article.date).format('YYYY.MM.DD').toString() }}</div>

        <div v-if="article.deadlineDate">
          Határidő:
          <strong>{{ moment(article.deadlineDate).format('YYYY.MM.DD').toString() }}</strong>
        </div>

        <div v-if="article.mandatory" class="mandatory">
          <a-tag color="red">Kötelező feladat</a-tag>
        </div>
      </div>
    </header>

    <article>
      <div v-if="article.picture" class="article-image">
        <img :src="`/api/v1/companies/1/images/${article.picture.id}/view?width=1920`"
             :alt="article.title" />
      </div>

      <div class="article-content">
        <div v-html="article.content" />

        <div v-for="widget in widgets" :key="widget.id" class="article-widget">
          <div v-if="widget.type.code === 'gallery' && widget.gallery">
            <BulletinGalleryComponent :id="widget.gallery.id" />
          </div>

          <div v-else-if="widget.type.code === 'content'" v-html="widget.content" />

          <div v-else-if="widget.type.code === 'documents'">
            <div class="bulletin-documents-container">
              <BulletinFileComponent v-for="file in widget.documents" :key="file.id" :file="file" />
            </div>
          </div>

          <div v-else-if="widget.type.code === 'youtube' && widget.videoId">
            <iframe :src="`https://www.youtube.com/embed/${widget.videoId}`"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </div>

      <BulletinReadArticleComponent v-if="article.mandatory" :id="article.id" />
    </article>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import BulletinGalleryComponent from "@/components/neta/bulletin/BulletinGalleryComponent.vue";
import BulletinFileComponent from "@/components/neta/bulletin/BulletinFileComponent.vue";
import BulletinReadArticleComponent from "@/components/neta/bulletin/BulletinReadArticleComponent.vue";

export default {
  components: { BulletinReadArticleComponent, BulletinFileComponent, BulletinGalleryComponent },
  computed: {
    moment() {
      return moment
    },
    widgets() {
      if (this.article === undefined || this.article.widgets === undefined) {
        return [];
      }

      const widgets = [...this.article.widgets];

      widgets.sort((a, b) => {
        return a.weight - b.weight;
      });

      return widgets;
    }
  },
  mounted() {
    this.fetchArticle();
  },
  data() {
    return {
      loading: false,
      article: undefined
    }
  },
  methods: {
    fetchArticle() {
      this.loading = true;
      return new Promise((resolve) => {
        axios.get(
            '/api/v1/companies/1/bulletin/news', {
              params: {
                filter: {
                  'slug': this.$route.params.slug
                }
              }
            }
        ).then((response) => {
          if (response.status !== 200 || response.data.length === 0) {
            throw new Error("Article not found");
          }

          this.article = response.data[0];

          resolve(this.article);

          this.loading = false;
        }).catch(() => {
          this.loading = true;
          this.$message.error(
              'A cikk betöltése sikertelen!'
          );
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2em;
}

.bulletin-container {
  padding: 25px;
  max-width: 1024px;
  margin: auto;
}

@media (min-width: 767px) {
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  header .article-info {
    text-align: right;
  }
}

header .article-info {
  font-size: 12px;
}

header .article-categories {
  margin-bottom: 8px;
}

article {
  margin: 12px 0;
  background: #FFF;
  border: 1px solid #EFEFEF;
}

article .article-image {
  overflow: hidden;
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  aspect-ratio: 16/9;
}

article .article-image img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

article .article-content {
  padding: 12px;
}

.article-widget {
  margin: 24px 0;
}

iframe {
  width: 100%;
  aspect-ratio: 16/9;
}

.bulletin-documents-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
}

.mandatory {
  margin-top: 8px;
}
</style>